import messages, { Messages } from 'Translations/index'

export const getIntlConfig = (
  language: string,
  locale: string,
): { locale: string; messages: Messages[0] } => ({
  locale,
  messages: messages[language] || messages.en,
})
